import { Theme, css } from '@emotion/react';
import React from 'react';

type Props = {
  header?: React.ReactElement;
  body?: React.ReactElement | null;
};

export const PaymentMethod = (props: React.PropsWithChildren<Props>) => {
  return (
    <>
      <div css={paymentOption}>{props.header}</div>
      {props.body ? <div css={creditCardDetails}>{props.body}</div> : null}
    </>
  );
};

const creditCardDetails = (theme: Theme) => css`
  padding: ${theme.spacing(3)}px;
  background: ${theme.colors.bgLight};
  overflow: auto;
  column-width: 500px;
`;

const paymentOption = (theme: Theme) => css`
  height: ${theme.typography.pxToRem(80)};
  display: flex;
  :not(:last-child) {
    border-bottom: 1px solid ${theme.colors.borderDefault};
  }
  * {
    margin: 0;
  }

  label {
    margin: 0;
  }
`;
